import { BaseEdge, EdgeLabelRenderer } from '@xyflow/react';
import type { Edge, EdgeProps } from '@xyflow/react';

import { EMPTY_ARRAY } from '@e-socna/empty';

import { pointsToRoundedPath } from './utils/points-to-rounded-path.util';
import type { WorkflowEdgeData } from './utils/build-workflow-graph.util';

type Props = EdgeProps<Edge<WorkflowEdgeData>>;

export const WorkflowEdge = ({ data, label, markerEnd, style }: Props) => {
  const points = data?.points ?? EMPTY_ARRAY;
  const path = pointsToRoundedPath(points);
  const labelPoint =
    data?.labelPosition ?? points[Math.floor(points.length / 2)];

  return (
    <>
      {/* eslint-disable-next-line react/forbid-component-props -- BaseEdge is an xyflow primitive, styled via its own `style` prop rather than `sx` */}
      <BaseEdge markerEnd={markerEnd} path={path} style={style} />
      {label && labelPoint ? (
        <EdgeLabelRenderer>
          <div
            className="nodrag nopan"
            style={{
              background: 'var(--xy-edge-label-background-color)',
              color: 'var(--xy-edge-label-color)',
              fontSize: 12,
              padding: '0 4px',
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${String(labelPoint.x)}px, ${String(labelPoint.y)}px)`,
            }}
          >
            {label}
          </div>
        </EdgeLabelRenderer>
      ) : null}
    </>
  );
};
